import { Injectable } from '@angular/core';
import { CompanySettingsService } from 'src/app/services/company-settings.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private cubeConfig: any;

  constructor(public settingsCompany: CompanySettingsService) {
    // console.log("In Config Service",this.settingsCompany)
   }

  loadConfigFromDB(){
     return this.settingsCompany.GetConfigClientSettings()
  }

  getConfig(){
    return this.cubeConfig; 
  }
  
  setConfig(value){
    this.cubeConfig = value; 
  }

}
